export default __webpack_public_path__ + "3285bcedd701996c43744069de64b362.svg";